export interface PaletteColors {
  primary: string;
  secondary: string;
}

export interface ColorPalette {
  id: string;
  name: string;
  light: PaletteColors;
  dark: PaletteColors;
}

function hex(value: string): string {
  return value.trim().toUpperCase();
}

function samePair(a: PaletteColors, b: PaletteColors): boolean {
  return hex(a.primary) === hex(b.primary) && hex(a.secondary) === hex(b.secondary);
}

export const COLOR_PALETTES: ColorPalette[] = [
  {
    id: 'default',
    name: 'Défaut',
    light: { primary: '#6B21A8', secondary: '#F59E0B' },
    dark: { primary: '#C084FC', secondary: '#FBBF24' }
  },
  {
    id: 'orchid',
    name: 'Orchidée',
    light: { primary: '#7E22CE', secondary: '#D97706' },
    dark: { primary: '#E879F9', secondary: '#FBBF24' }
  },
  {
    id: 'ocean',
    name: 'Océan',
    light: { primary: '#0E7490', secondary: '#EA580C' },
    dark: { primary: '#22D3EE', secondary: '#FB923C' }
  },
  {
    id: 'forest',
    name: 'Forêt',
    light: { primary: '#166534', secondary: '#CA8A04' },
    dark: { primary: '#4ADE80', secondary: '#EAB308' }
  },
  {
    id: 'sunset',
    name: 'Sunset',
    light: { primary: '#C2410C', secondary: '#B45309' },
    dark: { primary: '#FB923C', secondary: '#FBBF24' }
  },
  {
    id: 'night',
    name: 'Nuit',
    light: { primary: '#1D4ED8', secondary: '#F59E0B' },
    dark: { primary: '#818CF8', secondary: '#FBBF24' }
  },
  {
    id: 'rose',
    name: 'Rose',
    light: { primary: '#9D174D', secondary: '#C2410C' },
    dark: { primary: '#F472B6', secondary: '#FB923C' }
  },
  {
    id: 'jade',
    name: 'Jade',
    light: { primary: '#0F766E', secondary: '#F59E0B' },
    dark: { primary: '#2DD4BF', secondary: '#FBBF24' }
  },
  {
    id: 'crimson',
    name: 'Cramoisi',
    light: { primary: '#B91C1C', secondary: '#EA580C' },
    dark: { primary: '#FB7185', secondary: '#FDBA74' }
  },
  {
    id: 'indigo',
    name: 'Indigo',
    light: { primary: '#4338CA', secondary: '#DB2777' },
    dark: { primary: '#A78BFA', secondary: '#F472B6' }
  }
];

export const LIGHT_DEFAULT_COLORS = COLOR_PALETTES[0].light;
export const DARK_DEFAULT_COLORS = COLOR_PALETTES[0].dark;

export function paletteColors(palette: ColorPalette, dark: boolean): PaletteColors {
  return dark ? palette.dark : palette.light;
}

export function findPaletteByColors(primary?: string, secondary?: string): ColorPalette | undefined {
  if (!primary || !secondary) return undefined;
  const pair = { primary, secondary };
  return COLOR_PALETTES.find(
    palette => samePair(palette.light, pair) || samePair(palette.dark, pair)
  );
}

export function isPaletteSelected(
  palette: ColorPalette,
  dark: boolean,
  primary?: string,
  secondary?: string
): boolean {
  if (!primary || !secondary) return false;
  return samePair(paletteColors(palette, dark), { primary, secondary });
}
